<div class="modal-header on_dark">
    <h3>Confirm Account Number</h3>
  <button unity-button 
    class="icon-only xlarge close on_dark" 
    aria-label="Close"
    (click)="cancel()">
        <svg class="unity-icon-times">
            <use xlink:href="#unity-icon-times"></use>
        </svg>
    </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="accountNumber">Account Number</label>
      <kendo-maskedtextbox
        id="accountNumber"
        formControlName="accountNumber"
        [appNumberingMask]="editMask"
        [title]="helpText"
        [includeLiterals]="true"
      ></kendo-maskedtextbox>
    </div>
  </form>
</div>

<div class="modal-footer">
    <ng-container *sm-has-not-env-flag="'auroraV1'">
        <button unity-button class="primary" [disabled]="!form.valid" (click)="save()">Save</button>
        <button unity-button class="tertiary" (click)="cancel()">Cancel</button>
    </ng-container>
    <ng-container *sm-has-env-flag="'auroraV1'">
        <aurora-button [disabled]="!form.valid" (click)="save()">Save</aurora-button>
        <aurora-button variant="tertiary" class="ms-2" (click)="cancel()">Cancel</aurora-button>
    </ng-container>
</div>
